export default {
  'not-found': 'Page not found',
  'internal-error': 'Impossibile elaborare la richiesta',
  'preview-error':
    '<strong>The article slug is invalid</strong>.<br/> Check that the slug field has been filled in and that the article has been <strong>published</strong> or <strong>saved as a draft</strong>.',
  continue: 'Continue browsing',
  'no-search-results': 'Nessun risultato trovato',
  'back-to-home': 'Torna in home',
}
